<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Membership Agreement</p>
        </header>
        <section class="modal-card-body">
            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Velit porro quam eaque quisquam! Obcaecati iure, sapiente deserunt facilis dicta ex ea sed. Hic excepturi expedita magnam explicabo suscipit iure similique!</p>
        </section>
        <footer class="modal-card-foot">
            <button class="button is-info" type="button" @click="$parent.close()">Go Back</button>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'MemberCondition',
    data() {
        return {

        }
    }
}
</script>

<style scoped>
.top-10 {
    margin-top: 10px !important;
}
</style>
